import { render, staticRenderFns } from "./show.vue?vue&type=template&id=30564f43&scoped=true&"
import script from "./show.js?vue&type=script&lang=js&"
export * from "./show.js?vue&type=script&lang=js&"
import style0 from "./show.scoped.scss?vue&type=style&index=0&id=30564f43&lang=scss&scoped=true&"
import style1 from "./show.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30564f43",
  null
  
)

export default component.exports